<template>
    <div
        v-loading="loading" class="s-container"
        :style="'background-image:url(' + bgImg + ')'"
    >
        <div v-if="articleList">
            <section class="title-wrapper">
                <div
                    :class="['title', !!articleList.app_id ? 'c-gap-right' : '']"
                >
                    <div
                        class="clamp-content clamp-content-2"
                        :class="pageTitle.length < 9 ? 'c-gap-top' : ''"
                    >
                        {{ pageTitle }}
                    </div>
                </div>
                <div
                    v-if="!!articleList.app_id" class="go-zone"
                    @click="jump2ZonePage"
                >
                    <div class="text">去游戏专区</div>
                    <img :src="articleList.icon" class="icon">
                    <img :src="right" class="arrow">
                </div>
            </section>
            <section
                v-if="isList && articleList && articleList.data && articleList.data.length"
                class="wrapper list-wrapper"
            >
                <div
                    v-for="(v, k) of articleList.data" :key="k"
                    class="list-wrapper-item" @click="jumpHandle(v, k)"
                >
                    <answer-item
                        :item="v"
                    />
                </div>
            </section>
            <section
                v-else class="wrapper content-wrapper"
                :style="{
                    maxHeight: showMore ? '120vw' : '',
                    overflow: 'hidden',
                }"
            >
                <div v-if="!isTop1" class="title clamp-content clamp-content-2">{{ articleInfo.title }}</div>
                <div class="publisher">
                    <img :src="articleInfo.portrait" class="left">
                    <div class="right">
                        <div class="name">{{ articleInfo.user_name }}</div>
                        <div class="time">{{ articleInfo.publish_time }}</div>
                    </div>
                </div>
                <!-- postType===2时显示视频 -->
                <div v-if="articleInfo.postType === 2" class="media">
                    <video-box
                        :poster="articleInfo.video_info.video_image"
                        :src="articleInfo.video_info.video_url || ''"
                        :duration="articleInfo.video_info.video_duration"
                        :index="index"
                        :source="articleInfo.source"
                        :h5="articleInfo.h5_page_url || ''"
                    />
                </div>
                <!-- postType===1时显示图文 -->
                <div v-if="articleInfo.postType === 1">
                    <div v-if="articleInfo.content" class="article">
                        <!-- eslint-disable -->
                    <!--bca-disable-->
                        <div
                            v-lazy-container="{ selector: 'img' }"
                            v-html="articleInfo.content"
                        >
                        </div>
                        <!--bca-enable-->
                    <!-- eslint-enable -->
                    </div>
                    <div v-else class="article">
                        <div
                            v-if="articleInfo.head_part" class="article-wrapper"
                            @click="showAllArticle('answer')"
                        >
                            <div
                                v-if="articleInfo.source === 12" class="article-text clamp-text"
                                line-clamp="5"
                            >
                                <button class="btn" type="button">全文</button>
                                {{ articleInfo.head_part }}
                            </div>
                            <div v-else class="article-text">{{ articleInfo.head_part }}</div>
                        </div>
                        <img
                            v-if="articleInfo.images[0] && articleInfo.images[0].url"
                            class="pic"
                            :src="articleInfo.images[0].url"
                        >
                    </div>
                    <div
                        v-if="showMore"
                        class="showMore"
                        @click="showXiuxiuBottomDrawer"
                    >
                        <span>点击阅读全文</span>
                        <img :src="ShowMoreIcon" class="ShowMoreIcon">
                    </div>
                </div>
            </section>
        </div>
        <section v-if="!isList && articleList && articleList.data && articleList.data.length" class="more-answer">
            <div class="text">更多回答</div>
            <div
                v-for="(v, k) of articleList.data" :key="k"
                class="more-answer-item" @click="jumpHandle(v, k)"
            >
                <answer-item
                    :item="v"
                />
            </div>
        </section>
        <section v-if="rankList && rankList.length" class="rank-recommend-wrapper">
            <rank-recommend
                :more-rank="rankList"
            />
        </section>
        <section
            v-if="goodsInfo"
            :class="['entrance-bar', showEntranceBar ? 'entrance-bar-show' : 'entrance-bar-hide']"
            @click="toDetailPage"
        >
            <entrance-bar-detail
                :goods-info="goodsInfo.goods_info"
                :app-id="articleList.app_id"
                :channelid="channelid"
                :query="query"
                :page-type="pageType"
                :game-name="gameName"
            />
        </section>
        <xiuxiu-bottom-drawer
            :visible.sync="drawerVisible"
            :bg-color="buttonBg"
            :top-type="topType"
            :answer-id="articleInfo.answer_id"
            :app-id="articleList.app_id"
            :cid="cid"
            :index="index"
            :pblog="getPblog()"
            :must-down-load="mustDownLoad"
            @seeMoreContent="seeMoreContent"
        />
        <xiuxiu-box
            :answer-id="articleInfo.answer_id"
            :app-id="articleList.app_id"
            :cid="cid"
            :do-display-log="doDisplayLog"
            :do-click-log="doClickLog"
            :from="from"
            @showXiuxiuDrawer="showXiuxiuBottomDrawer"
        />
    </div>
</template>
<script>
import AnswerItem from './components/answer-item';
import RankRecommend from './components/rank-recommend';
import VideoBox from './components/app-video-box';
import EntranceBarDetail from '@/components/entranceBar/entrance-bar-detail.vue';
import api from '@/api';
import {getUrlParams, getQueryString} from '@/utils/url';
import {isShow, on} from '@/utils/dom';
import {browserDetect} from '@/utils/browser';
import {openPage, openSmartAppInsideBdApp, getDeepValue, openSmartAppInsideApp} from '@/utils/utility';
import {compressWithGimg, replaceImgSrc2Datasrc} from '@/utils/gimg';
import right from 'public/assets/imgs/ic_next_white.png';
import {throttle} from 'throttle-debounce';
import XiuxiuBox from './components/xiuxiubox';
import ShowMoreIcon from 'public/assets/imgs/ic_arraw_down_blue.png';
import XiuxiuBottomDrawer from '@/pages/answer-detail/components/XiuxiuBottomDrawer';


export default {
    components: {
        RankRecommend,
        AnswerItem,
        VideoBox,
        EntranceBarDetail,
        XiuxiuBox,
        XiuxiuBottomDrawer,
    },
    data() {
        return {
            rankList: null,
            loading: true,
            right: right,
            fold: true,
            index: 99,
            articleInfo: null,
            articleList: null,
            query: decodeURI(getQueryString('query')),
            isList: getQueryString('location') === 'title',
            viewAll: false,
            playEnd: false,
            isSem: 0,
            showEntranceBar: true, // 是否展示电商入口底部信息
            entranceBarFun: null, // 底部信息节流
            entranceBarFunTimer: null, // 电商入口信息底部bar展示时间
            isForceShopShow: 0, // 强制展示商品信息，1强制展示
            goodsInfo: {},
            drawerVisible: false,
            from: 'gameQaDetail',
            cid: getQueryString('cid'),
            channelid: getQueryString('channelid'),
            srcid: getQueryString('srcid'),
            gameName: decodeURI(getQueryString('game')),
            ShowMoreIcon,
            topType: 3,
            buttonBg: '',
            showMore: false,
            appData: {},
            mustDownLoad: true,
            isTop1: getQueryString('source').toLowerCase() === 'top1',
        };
    },
    computed: {
        // isfold() {
        //     return this.articleInfo.head_part.length > 92
        // },
        pageType() {
            switch (getQueryString('location')) {
                case 'title': return '标题';
                case 'article': return '文章';
                case 'video': return '视频';
                default: return '';
            }
        },
        bgImg() {
            const bg = getDeepValue(this.articleList, 'background');
            return bg && compressWithGimg({
                url: bg,
                size: 'w1242',
                q: 100,
            });
        },
        answerId() {
            return getQueryString('answer_id') ? getQueryString('answer_id') : getQueryString('cid');
        },
        pageTitle() {
            if (this.isList || !this.isTop1) {
                return this.query;
            }
            return this.articleInfo.title || '';
        },
    },
    async created() {
        let {channelid, cid, game, query, source, answer_id, qa_from, srcid} = getUrlParams();
        let params = {
            data: {
                pNum: '1',
                pSize: '3',
                channelId: channelid,
            },
        };
        let aParams = {
            data: {
                cid: cid,
                game: decodeURI(game),
                query: decodeURI(query),
                source: source,
                answer_id: answer_id,
                qa_from: qa_from,
                check_tieba: +srcid === 5859 ? 1 : 0,
            },
        };
        let articleResult = {};
        const p1 = api.strategy.getArticleResult(aParams).catch(e => console.log(e));
        const p2 = api.strategy.getRankResult(params).catch(e => console.log(e));
        await Promise.all([p1, p2]).then(res => {
            articleResult = res[0] || {};
            this.rankList = res[1] || [];
        });
        this.rankList.map(e => {
            e.games && e.games.map(item => {
                item.icon = compressWithGimg({
                    url: item.icon,
                    width: 512,
                    height: 512,
                    q: 90,
                });
            });
        });
        this.compressImg(articleResult);
        const list = getDeepValue(articleResult, 'list');
        this.appData = getDeepValue(articleResult, 'xiuxiu_info');
        list && this.compressImgsList(list.data);
        this.articleList = list || {};
        this.articleInfo = getQueryString('location') !== 'title'
            ? articleResult.detail : {};
        this.loading = false;
        // this.initLog();
        const {browserVersion, browserName} = window.detailUserAgentInfo;
        this.$root.extData = {
            browserVersion,
            browserName,
            sid: getQueryString('sid') || '',
            srcId: getQueryString('srcid') || '',
            pageType: this.pageType,
            title: decodeURI(getQueryString('query')),
            gameName: decodeURI(getQueryString('game')),
            gameId: list.app_id,
            gameType: list.app_type || '',
        };
        this.doShowLog({});
        let that = this;
        window.onbeforeunload = function () {
            that.unFinish();
        };
        // 滚动时底部bar不展示，节流函数控制
        this.entranceBarFun = throttle(200, this.getEntranceBarShow);
        on(window, 'scroll', this.entranceBarFun);
        this.isSem = Number(getQueryString('from') === 'sem');
        // 方便查看数据,直接在链接上添加字段，强制展示商品信息
        this.isForceShopShow = getQueryString('isForceShopShow') ? Number(getQueryString('isForceShopShow')) : 0;
        this.articleList.app_id && this.getGoodsInfo();
        if (this.appData !== undefined) {
            this.showMore = true;
            this.doDisplayLog({
                gameId: this.articleList.app_id,
                gameName: this.gameName,
                platform: this.appData ? 'android' : 'ios',
                boxVersion: '', // 版本号
                gameType: '', // 游戏类型
                title: this.articleInfo.title, // 标题
            }, 'more');
        }
        this.mustDownLoad = this.appData.must_download;
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.initLog();
            }, 500);
        });
    },
    methods: {
        initLog() {
            let doms = [];
            if (getQueryString('location') === 'title') {
                doms = document.querySelectorAll('.list-wrapper-item');
            }
            else {
                doms = document.querySelectorAll('.more-answer-item');
                let value = 'answer';
                if (getQueryString('location') === 'video') {
                    value = 'video';
                }
                this.doDisplayLog({
                    answerId: this.answerId,
                    contentFrom: getQueryString('source') || '',
                }, value);
                if (getQueryString('location') === 'article') {
                    let dom = document.querySelector('.more-answer');
                    if (dom) {
                        isShow(dom, false, () => {
                            if (!this.viewAll) {
                                this.doClickLog('readFinish', {
                                    answerId: this.answerId,
                                    contentFrom: getQueryString('source') || '',
                                    readFinish: 'yes',
                                });
                            }
                            this.viewAll = true;
                        });

                    }

                }
            }
            let arr = [];
            isShow(doms, true, (val, i) => {
                if (!arr.includes(i)) {
                    arr.push(i);
                    let item = this.articleList.data[i];
                    let value = 'answer';
                    if (item.postType === 2) {
                        value = 'video';
                    }
                    this.doDisplayLog({
                        answerId: item.answer_id ? item.answer_id : item.cid,
                        contentFrom: item.source_name,
                        nextPage: item.tiebaData?.url ? 'tieba' : 'game',
                    }, value, i + 1);
                }
            });
        },
        compressImgsList(data) {
            try {
                data && data.map(e => {
                    let big_images = getDeepValue(e, 'big_images');
                    big_images && big_images.map(e => {
                        e.url = compressWithGimg({
                            url: e.url,
                            width: 621,
                            height: 375,
                            q: 90,
                        });
                    });
                    e.big_images = big_images;
                    let images = getDeepValue(e, 'images');
                    images && images.map(e => {
                        e.url = compressWithGimg({
                            url: e.url,
                            width: 621,
                            height: 375,
                            q: 90,
                        });
                    });
                    e.images = images;
                });
            }
            catch (e) {
                console.log(e);
            }

        },
        getGoodsInfo() {
            let goodsInfoParams = {
                data: {
                    app_id: this.articleList.app_id,
                    is_sem: this.isSem,
                    is_force_shop_show: this.isForceShopShow,
                    channel: getQueryString('channelid') || getQueryString('idfrom'),
                },
            };
            // 获取电商商品信息数据
            api.zone.getGoodsInfo(goodsInfoParams).then(goodsInfo => {
                this.goodsInfo = goodsInfo;
                // 底部电商入口展现打点
                if (this.goodsInfo.goods_info) {
                    this.doDisplayLog({
                        gameId: this.articleList.app_id,
                        srcId: 5859,
                        gameName: this.gameName,
                    }, 'qaBuy');
                }
            }).catch(err => {
                console.log(err);
            });
        },
        doShowLog(obj, value) {
            this.$logger.show({
                value: value || '',
                ext: {
                    item: [
                        {
                            id: '',
                            ext: Object.assign(obj, this.$root.extData),
                            pos: '',
                        },
                    ],
                },
            });
        },
        doDisplayLog(obj, value, pos) {
            this.$logger.display({
                value: value || '',
                ext: {
                    item: [
                        {
                            id: '',
                            ext: Object.assign({}, this.$root.extData, obj),
                            pos: pos || '',
                        },
                    ],
                },
            });
        },
        doClickLog(value, obj, index, pkg) {
            let content = {
                value: value,
                ext: {
                    id: pkg || '',
                    ext: Object.assign({}, this.$root.extData, obj),
                    pos: index || '',
                },
            };
            this.$logger.click(content);
        },
        doShowItemsLog(list) {
            list.forEach(item => {
                item.games.forEach((v, k) => {
                    this.$logger.showItems({
                        value: '',
                        ext: {
                            item: [
                                {
                                    id: v.package_name || '',
                                    ext: Object.assign({}, this.$root.extData, {
                                        gameName: v.app_name,
                                        gameType: '',
                                        gameId: v.appid,
                                        moduleName: item.rank_name,
                                    }),
                                    pos: k + 1,
                                },
                            ],
                        },
                    });
                });
            });
        },
        jumpStrategy(obj, key) {
            let url = location.href;
            url = this.handleUrl(url, 'cid', obj.cid);
            url = this.handleUrl(url, 'answer_id', obj.answer_id);
            url = this.handleUrl(url, 'source', obj.source_name);
            let pageType = 'article';
            if (obj.postType === 2) {
                pageType = 'video';
            }
            setTimeout(() => {
                location.href = this.replaceParamVal(url, 'location', pageType);
            }, 100);
        },
        jumpHandle(obj, key) {
            const inBdBoxapp = browserDetect('bdbox');
            const sid = getQueryString('sid') || '';
            const {scheme, url} = obj.tiebaData || {};
            if (inBdBoxapp) {
                if (scheme) {
                    openSmartAppInsideApp(scheme);
                }
                else {
                    openSmartAppInsideBdApp('pages/questionDetail/index', {
                        appId: this.articleList.app_id,
                        cid: obj.cid,
                        answerId: obj.answer_id,
                        sid,
                    });
                }
            }
            else {
                let link = '';
                if (url) {
                    link = url;
                }
                else if (sid === '183308') {
                    // eslint-disable-next-line max-len
                    link = `/static/game/answer-detail.html?cid=${obj.cid}&appId=${this.articleList.app_id}&answerId=${obj.answer_id}`;
                }
                if (link) {
                    setTimeout(() => {
                        location.href = link;
                    }, 100);
                }
                else {
                    this.jumpStrategy(obj, key);
                }
            }
            this.doClickLog('answer', {
                answerId: obj.answer_id ? obj.answer_id : obj.cid,
                contentFrom: obj.source_name,
                nextPage: url ? 'tieba' : 'game',
            }, key + 1);
        },
        jump2ZonePage() {
            setTimeout(() => {
                const inBdBoxapp = browserDetect('bdbox');
                if (inBdBoxapp) {
                    openSmartAppInsideBdApp('pages/app/index', {
                        appId: this.articleList.app_id,
                        init_tab: 'answers',
                    });
                }
                else {
                    openPage('zone', {
                        appId: this.articleList.app_id,
                        channelid: getQueryString('channelid'),
                        srcid: getQueryString('srcid'),
                        tab: 'answer',
                    });
                }
            }, 100);
            this.doClickLog('gameZone', {
                answerId: this.answerId,
            });
        },
        showAllArticle(value) {
            if (this.articleInfo.source === 12) {
                location.href = this.articleInfo.h5_page_url;
            }
            this.doClickLog(value, {
                contentFrom: getQueryString('source') || '',
                answerId: this.answerId,
            });
        },
        handleUrl(url, key, value) {
            url = this.removeParamVal(url, key);
            if (value) {
                url += '&' + key + '=' + value;
            }
            return url;
        },
        replaceParamVal(oUrl, paramName, replaceWith) {
            let re = new RegExp('(&' + paramName + '=)([^&]*)', 'gi');
            let nUrl = oUrl.replace(re, '&' + paramName + '=' + replaceWith);
            return nUrl;
        },
        removeParamVal(oUrl, paramName) {
            let re = new RegExp('(&' + paramName + '=)([^&]*)', 'gi');
            let nUrl = oUrl.replace(re, '');
            return nUrl;
        },
        unFinish() {
            if (!this.viewAll && getQueryString('location') === 'article') {
                this.doClickLog('readFinish', {
                    answerId: this.answerId,
                    contentFrom: getQueryString('source') || '',
                    readFinish: 'no',
                });
            }
            if (!this.playEnd && getQueryString('location') === 'video') {
                this.doClickLog('playFinish', {
                    answerId: this.answerId,
                    contentFrom: getQueryString('source') || '',
                    playFinish: 'no',
                });
            }
        },
        compressImg(articleResult) {
            try {
                // 处理富文本
                const richtext = getDeepValue(articleResult, 'detail.content');
                if (richtext) {
                    articleResult.detail.content = replaceImgSrc2Datasrc(richtext, {
                        size: 'w1242',
                        q: 100,
                    });
                }
                // 处理 icon
                const icon = getDeepValue(articleResult, 'list.icon');
                if (icon) {
                    articleResult.list.icon = compressWithGimg({url: icon, size: 'w144', q: 100});
                }
                // 处理头像
                if (getQueryString('location') !== 'title') {
                    const portrait = getDeepValue(articleResult, 'detail.portrait');
                    if (portrait) {
                        articleResult.detail.portrait = compressWithGimg({
                            url: portrait,
                            size: 'w105',
                            q: 100,
                        });
                    }
                }
            }
            catch (e) {
                console.log(e);
            }
        },
        // 底部电商信息展示一定时间消失
        getEntranceBarShow() {
            this.showEntranceBar = false;
            if (this.entranceBarFunTimer) {
                clearTimeout(this.entranceBarFunTimer);
            }
            this.entranceBarFunTimer = setTimeout(() => {
                this.showEntranceBar = true;
                this.entranceBarFunTimer = null;
            }, 800);
        },
        // 底部入口跳转详情页
        toDetailPage() {
            openPage('zone', {
                appId: this.articleList.app_id,
                channelid: this.channelid,
                srcid: 5859,
                query: this.query,
            });
            this.doClickLog('qaBuy', {
                gameId: this.articleList.app_id,
                srcId: 5859,
                gameName: this.gameName,
            });
        },
        getPblog() {
            return {
                gameId: this.articleList.app_id,
                gameName: this.gameName,
                platform: this.appData ? 'android' : 'ios',
                boxVersion: '', // 版本号
                gameType: this.$root.extData.gameType || '', // 游戏类型
                title: this.articleInfo.title, // 标题
            };
        },
        showXiuxiuBottomDrawer() {
            this.doClickLog('more', {
                gameId: this.articleList.app_id,
                gameName: this.gameName,
                platform: this.appData ? 'android' : 'ios',
                boxVersion: '', // 版本号
                gameType: this.$root.extData.gameType || '', // 游戏类型
                title: this.articleInfo.title, // 标题
            });
            this.drawerVisible = true;
        },
        seeMoreContent() {
            this.doClickLog('answerContinue', {
                gameId: this.articleList.app_id,
                gameName: this.gameName,
                platform: this.appData ? 'android' : 'ios',
                boxVersion: '', // 版本号
                gameType: '', // 游戏类型
                title: this.articleInfo.title, // 标题
            });
            this.showMore = false;
        },
    },
};
</script>
<style lang="scss">
    @import "~@/common/style/mixin/utils";
    @import "~@/common/style/mixin/border";

    $design-width: 1242;
    $max-device-width: 768px;

    html {
        @include root-font-size();
    }

    html, body {
        padding: 0;
        margin: 0;
    }

    .over-ellipsis {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .c-gap-top {
        margin-top: px2rem(70);
    }
    .c-gap-right {
        margin-right: px2rem(90);
    }
    .clamp-content {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
    }
    .clamp-content-1 {
        -webkit-line-clamp: 1;
    }
    .clamp-content-2 {
        -webkit-line-clamp: 2;
    }
    .clamp-content-5 {
        -webkit-line-clamp: 5;
    }
    .last-item {
        @include border-single(bottom, 0, #E0E0E0);
        margin-bottom: 0 !important;
        padding-bottom: 0 !important;
    }
    .s-container {
        padding: 0 px2rem(30);
        background-repeat: no-repeat;
        background-size: 100% px2rem(699);
        background-color: #F8F8F8;
        padding-top: px2rem(229);
        .title-wrapper {
            height: px2rem(470);
            padding: px2rem(100) px2rem(60) 0 px2rem(60);
            margin: 0 px2rem(-30);
            background-image: linear-gradient(180deg, rgba(0,0,0,0.00) 0%, rgba(0,0,0,0.50) 75%, #F8F8F8 100%);
            box-sizing: border-box;
            color: #fff;
            display: flex;
            .title {
                height: px2rem(180);
                font-size: px2rem(72);
            }
            .go-zone {
                margin-left: auto;
                // width: px2rem(390);
                height: px2rem(108);
                box-shadow: 0 px2rem(10) px2rem(20) 0 rgba(13,76,164,0.30);
                border-radius: px2rem(27);
                background-color: #38f;
                font-size: px2rem(42);
                padding: 0 px2rem(27);
                box-sizing: border-box;
                display: flex;
                align-items: center;
                margin-top: px2rem(72);
                flex-shrink: 0;
                .icon {
                    width: px2rem(74);
                    height: px2rem(74);
                    border-radius: px2rem(18);
                    margin: 0 px2rem(18);
                }
                .arrow {
                    width: px2rem(15);
                }
            }
        }
        .wrapper {
            background-color: #fff;
            border-radius: px2rem(36);
            margin-top: px2rem(-130);
            margin-bottom: px2rem(45);
            padding: px2rem(54) px2rem(39);
            color: #1f1f1f;
        }
        .list-wrapper {
            &-item:last-child>div {
                @extend .last-item;
            }
        }
        .content-wrapper {
            position: relative;
            .title {
                font-size: px2rem(72);
                margin-bottom: px2rem(70);
            }
            .publisher {
                display: flex;
                align-items: center;
                margin-bottom: px2rem(70);
                .left {
                    width: px2rem(105);
                    height: px2rem(105);
                    border-radius: 50%;
                    margin-right: px2rem(24);
                }
                .right {
                    .name {
                        font-size: px2rem(48);
                    }
                    .time {
                        font-size: px2rem(36);
                        // color: #858585;
                        color: #1F1F1F;
                    }
                }
            }
            .article {
                font-size: px2rem(57);
                .article-wrapper {
                    position: relative;
                    display: flex;
                    overflow: hidden;
                    font-size: px2rem(57);
                    color: #1F1F1F;
                    .article-text{
                        line-height: 1.5;
                        text-align:justify;
                    }
                    .clamp-text{
                        overflow: hidden;
                    }
                    [line-clamp="5"]{
                        max-height: 7.5em;
                    }
                    .clamp-text::before{
                        content:'';
                        float: right;
                        width: 0;
                        height: 100%;
                        margin-bottom: -1.6em;
                    }
                    .clamp-text::after{
                        content:'';
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        background: #fff;
                    }
                    .btn{
                        position: relative;
                        float: right;
                        margin-left: px2rem(60);
                        clear: both;
                        padding: 0;
                        border: none;
                        background: #fff;
                        font-size: 1em;
                        line-height: 1.5em;
                        color: #38f;
                    }
                    .btn::before{
                        content: '...';
                        position: absolute;
                        left: px2rem(-60);
                        color: #1F1F1F;
                    }
                }
                img {
                    width: 100% !important;
                    height: auto !important;
                }
                .pic {
                    height: px2rem(621) !important;
                    border-radius: px2rem(26);
                    margin-top: px2rem(60);
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: cover;
                }
            }
            .media {
                width: 100%;
                height: px2rem(621);
                margin-top: px2rem(90);
            }
            .showMore {
                width: 100%;
                height: px2rem(400);
                background-image: -webkit-linear-gradient(top,rgba(156, 190, 239, 0.001) 0%,
              #fff 60%,
              #fff 60%
                );
                color: #38f;
                text-align: center;
                line-height: px2rem(650);
                font-size: px2rem(52);
                position: absolute;
                top: px2rem(1200);
                left: px2rem(-30);
                .ShowMoreIcon {
                    width: px2rem(50);
                    height: px2rem(50);
                    position: absolute;
                    top: px2rem(300);
                }
            }
        }
        .more-answer {
            background-color: #fff;
            border-radius: px2rem(36);
            padding: px2rem(60) px2rem(39);
            margin-bottom: px2rem(48);
            color: #1f1f1f;
            .text {
                font-size: px2rem(57);
                font-weight: bold;
                margin-bottom: px2rem(60);
            }
            &-item:last-child>div {
                @extend .last-item;
            }
        }
        .entrance-bar {
            position: fixed;
            left: 0;
            width: 100%;
            transition: bottom 0.3s ease-out;
        }
        .entrance-bar-show {
            bottom: px2rem(0);
        }
        .entrance-bar-hide {
            bottom: px2rem(-400);
        }
    }
</style>